import { createContext, useContext } from 'react';

// The signed-in curator, provided by the shell once /admin/me has answered.
// Pages under the shell can rely on it being set.
interface CurrentCurator {
  id: string;
  fullName: string;
}

export const CurrentCuratorContext = createContext<CurrentCurator | null>(null);

export function useCurrentCurator(): CurrentCurator | null {
  return useContext(CurrentCuratorContext);
}
